<template>
    <div class="group" :class="state">
      <div class="leader">
        <div class="header">
          <div class="icon">
            <svg width="24" height="13" viewBox="0 0 25 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.6667 6.22222H10.8889C10.6826 6.22222 10.4848 6.30417 10.3389 6.45003C10.1931 6.59589 10.1111 6.79372 10.1111 7C10.1111 7.20628 10.1931 7.40411 10.3389 7.54997C10.4848 7.69583 10.6826 7.77778 10.8889 7.77778H11.6667C11.8729 7.77778 12.0708 7.69583 12.2166 7.54997C12.3625 7.40411 12.4444 7.20628 12.4444 7C12.4444 6.79372 12.3625 6.59589 12.2166 6.45003C12.0708 6.30417 11.8729 6.22222 11.6667 6.22222ZM11.6667 9.33333H10.8889C10.6826 9.33333 10.4848 9.41528 10.3389 9.56114C10.1931 9.707 10.1111 9.90483 10.1111 10.1111C10.1111 10.3174 10.1931 10.5152 10.3389 10.6611C10.4848 10.8069 10.6826 10.8889 10.8889 10.8889H11.6667C11.8729 10.8889 12.0708 10.8069 12.2166 10.6611C12.3625 10.5152 12.4444 10.3174 12.4444 10.1111C12.4444 9.90483 12.3625 9.707 12.2166 9.56114C12.0708 9.41528 11.8729 9.33333 11.6667 9.33333ZM7 4.66667H11.6667C11.8729 4.66667 12.0708 4.58472 12.2166 4.43886C12.3625 4.293 12.4444 4.09517 12.4444 3.88889C12.4444 3.68261 12.3625 3.48478 12.2166 3.33892C12.0708 3.19306 11.8729 3.11111 11.6667 3.11111H7C6.79372 3.11111 6.59589 3.19306 6.45003 3.33892C6.30417 3.48478 6.22222 3.68261 6.22222 3.88889C6.22222 4.09517 6.30417 4.293 6.45003 4.43886C6.59589 4.58472 6.79372 4.66667 7 4.66667ZM14.7778 0H3.88889C3.68261 0 3.48478 0.0819442 3.33892 0.227806C3.19306 0.373667 3.11111 0.571498 3.11111 0.777778V3.11111H0.777778C0.571498 3.11111 0.373667 3.19306 0.227806 3.33892C0.0819442 3.48478 0 3.68261 0 3.88889V11.6667C0 12.2855 0.245833 12.879 0.683418 13.3166C1.121 13.7542 1.71449 14 2.33333 14H12.4444C13.2696 14 14.0609 13.6722 14.6443 13.0888C15.2278 12.5053 15.5556 11.714 15.5556 10.8889V0.777778C15.5556 0.571498 15.4736 0.373667 15.3278 0.227806C15.1819 0.0819442 14.9841 0 14.7778 0ZM3.11111 11.6667C3.11111 11.8729 3.02917 12.0708 2.88331 12.2166C2.73744 12.3625 2.53961 12.4444 2.33333 12.4444C2.12705 12.4444 1.92922 12.3625 1.78336 12.2166C1.6375 12.0708 1.55556 11.8729 1.55556 11.6667V4.66667H3.11111V11.6667ZM14 10.8889C14 11.3014 13.8361 11.6971 13.5444 11.9888C13.2527 12.2806 12.857 12.4444 12.4444 12.4444H4.52667C4.61722 12.195 4.66456 11.932 4.66667 11.6667V1.55556H14V10.8889ZM7 7.77778H7.77778C7.98406 7.77778 8.18189 7.69583 8.32775 7.54997C8.47361 7.40411 8.55556 7.20628 8.55556 7C8.55556 6.79372 8.47361 6.59589 8.32775 6.45003C8.18189 6.30417 7.98406 6.22222 7.77778 6.22222H7C6.79372 6.22222 6.59589 6.30417 6.45003 6.45003C6.30417 6.59589 6.22222 6.79372 6.22222 7C6.22222 7.20628 6.30417 7.40411 6.45003 7.54997C6.59589 7.69583 6.79372 7.77778 7 7.77778ZM7 10.8889H7.77778C7.98406 10.8889 8.18189 10.8069 8.32775 10.6611C8.47361 10.5152 8.55556 10.3174 8.55556 10.1111C8.55556 9.90483 8.47361 9.707 8.32775 9.56114C8.18189 9.41528 7.98406 9.33333 7.77778 9.33333H7C6.79372 9.33333 6.59589 9.41528 6.45003 9.56114C6.30417 9.707 6.22222 9.90483 6.22222 10.1111C6.22222 10.3174 6.30417 10.5152 6.45003 10.6611C6.59589 10.8069 6.79372 10.8889 7 10.8889Z" fill="white"/>
              <path d="M24.25 6.25H19.75V1.75C19.75 1.55109 19.671 1.36032 19.5303 1.21967C19.3897 1.07902 19.1989 1 19 1C18.8011 1 18.6103 1.07902 18.4697 1.21967C18.329 1.36032 18.25 1.55109 18.25 1.75V6.25H13.75C13.5511 6.25 13.3603 6.32902 13.2197 6.46967C13.079 6.61032 13 6.80109 13 7C13 7.19891 13.079 7.38968 13.2197 7.53033C13.3603 7.67098 13.5511 7.75 13.75 7.75H18.25V12.25C18.25 12.4489 18.329 12.6397 18.4697 12.7803C18.6103 12.921 18.8011 13 19 13C19.1989 13 19.3897 12.921 19.5303 12.7803C19.671 12.6397 19.75 12.4489 19.75 12.25V7.75H24.25C24.4489 7.75 24.6397 7.67098 24.7803 7.53033C24.921 7.38968 25 7.19891 25 7C25 6.80109 24.921 6.61032 24.7803 6.46967C24.6397 6.32902 24.4489 6.25 24.25 6.25Z" fill="white"/>
            </svg>
          </div>
          <div class="content">
            <h3>{{ messages[state].title }}</h3>
            <p>{{ messages[state].byline }}</p>
          </div>
        </div>

        <div>
          <div class="features">
            <div v-for="(feature, idx) in features[state]" :key="idx">
              <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <!-- <rect class="rect" y="3" width="14" height="3"/> -->
                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.6209 0.225302C13.9213 0.525706 13.9213 1.01276 13.6209 1.31316L5.15931 9.7747C4.85891 10.0751 4.37186 10.0751 4.07146 9.7747L0.225302 5.92854C-0.0751008 5.62814 -0.0751008 5.14109 0.225302 4.84069C0.525706 4.54028 1.01276 4.54028 1.31316 4.84069L4.61538 8.14291L12.533 0.225302C12.8334 -0.0751008 13.3204 -0.0751008 13.6209 0.225302Z" fill="black"/>
              </svg>
              <span>{{ feature }}</span>
            </div>
          </div>
        </div>
      </div>

      <button @click="fireCta()">{{ messages[state].button }}</button>
    </div>
</template>

<script>
  export default {
    data() {
      return {
        features: {
          "sign-up": [
            'No ads. Ever.',
            'Unlimited stories',
            'Personalised news feed',
            'Support a small team'
          ],
          "go-pro": [
            'No ads. Ever.',
            'Unlimited stories',
            'Unlock full story timelines',
            'Support a small team'
          ]
        },

        messages: {
          "sign-up": {
            title: 'Join Nourish',
            byline: 'A healthier news diet.',
            button: 'Sign up for free'
          },
          "go-pro": {
            title: 'Nourish Pro',
            byline: '£5/month',
            button: 'Get started'
          }
        }
      }
    },

    props: ['state'],

    methods: {
      fireCta() {
        switch (this.state) {
          case 'sign-up':
            this.EventBus.$emit('modal:auth', 'sign-up');
            return;

          case 'go-pro':
            this.EventBus.$emit("didSelectSubscribe", {
              didSelect: 'true' 
            });
            return;
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5.scss';

  // -----------------------------------
  // States
  .sign-up {
    .leader {
      background: rgba($yellow-tone-3, 0.1);

      .icon {
        background: $yellow-tone-3;

        svg path {
          fill: $neutral-100;
        }
      }

      .features {
        svg rect {
          fill: $yellow-tone-3;
        }
      }
    }

    button {
      background: $yellow-tone-3;
      color: $neutral-100;
    }
  }

  .go-pro {
    .leader {
      background: rgba($green-tone-3, 0.1);

      .icon {
        background: $green-tone-3;

        svg path {
          fill: $neutral-600;
        }
      }

      .features {
        svg rect {
          fill: $green-tone-3;
        }
      }
    }

    button {
      background: $green-tone-3;
      color: $neutral-600;
    }
  }

  // -----------------------------------
  // Base
  .group {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .leader {
    display: flex;
    flex-direction: column;
    // width: 100%;
    padding: 1.5rem 1.5rem 3.5rem 1.5rem;
    border-radius: 10px;
    text-align: left;

    .header {
      display: flex;

      .content {
        display: flex;
        flex-direction: column;
      }
    }

    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 2.5rem;
      height: 2.5rem;
      margin-right: 1rem;
      border-radius: 10px;
      margin-top: 0.15rem;
    }

    h3 {
      margin: 0;
      font-weight: bold;
    }

    p {
      margin: 0;
      font-weight: bold;
    }
    
    div:not(.icon) {
      flex: 1;
    }
  }

  .features {
    display: flex;
    flex-direction: column;
    font-size: 0.9rem;
    font-weight: bold;
    margin-top: 0.5rem;

    svg {
      margin-right: 1rem;

      path {
        fill: $neutral-100;
        .darkmode & {
          fill: $neutral-600;
        }
      }
    }

    div {
      display: flex;
      align-items: center;
      margin-top: 0.8rem;
    }

    span {
      flex: 1;
    }
  }

  button {
    display: flex;
    justify-content: center;
    margin: -1.8rem 1.5rem 0 1.5rem;
  }
</style>